export interface MessageFileMetadata {
  name: string;
  type: string;
  size: string;
  source: string;
  imageWidth: string;
  imageHeight: string;
}

export enum ChatMessageMetaType {
  labReportUpload = "lab-report-upload",
  labValueDisplay = "lab-value-display",
  npsFeedback = "nps-feedback",
  csatFeedback = "csat-feedback"
}
